














import { Component, Vue } from 'vue-property-decorator';
import { appModule } from '@/store/modules/ModuleApp';
import { tagsViewModule } from '@/store/modules/ModuleTagsView';

@Component({
	name: 'SizeSelect'
})
/** SizeSelect */
export default class SizeSelect extends Vue {
	/** document hooks */
	private sizeOptions: any = [
		{
			label: 'Default',
			value: 'default'
		},
		{
			label: 'Medium',
			value: 'medium'
		},
		{
			label: 'Small',
			value: 'small'
		},
		{
			label: 'Mini',
			value: 'mini'
		}
	];

	/** document hooks */
	private get size(): any {
		return appModule.size;
	}

	/** document hooks */
	private handleSetSize(size: string): any {
		// eslint-disable-next-line consistent-this
		// eslint-disable-next-line @typescript-eslint/no-this-alias
		const thisVal: any = this;

		const element: any = thisVal.$ELEMENT;

		element.size = size;
		appModule.setSize(size);
		this.refreshView();
		this.$message({
			message: 'Switch Size Success',
			type: 'success'
		});
	}

	/** document hooks */
	private refreshView(): any {
		// In order to make the cached page re-rendered
		tagsViewModule.delAllCachedViews();
		const { fullPath }: any = this.$route;

		this.$nextTick(() => {
			this.$router.replace({ path: `/redirect${fullPath}` })['catch']((err: any): any => {
				console.warn(err);
			});
		});
	}
}
